import React from "react";
import { Link } from "react-router-dom";
import reliveLogo from "../assets/tv.svg";
import relivePreview from "../assets/cta0.png";
import aboutLogo from "../assets/djcomp.svg";
import aboutPreview from "../assets/aboutHero.png";
import resmailLogo from "../assets/aff.svg";
import "./freakyardcards.css";
import { useLanguage } from '../contexts/LanguageContext';

const AffiliateCards = () => {
  const { isArabic } = useLanguage();

  const translations = {
    replayDJSets: isArabic ? 'استمع إلى موسيقى الدي چاي المفضل لك في أي وقت على منصتنا الحصرية.' : 'Replay your favorite DJ sets anytime on our exclusive platform.',
    aboutUs: isArabic ? 'مسابقة الدي جي' : 'DJ COMP',
    aboutDescription: isArabic ? 'اغتنم الفرصة للأداء في فريك يارد' : 'Take the chance to perform like at freakyard',
    affiliate: isArabic ? 'أفلييت' : 'Affiliate',
    affiliateDescription: isArabic ? 'انضم إلى برنامجنا واربح جوائز مذهلة' : 'Join our program and win amazing prizes'
  };

  return (
    <div className="cta-cards-container">

      <div className="cta-cards-row">
        <a href="https://noteforms.com/forms/dj-competition-w9kzss" target="_blank" rel="noopener noreferrer" className="cta-card cta-card--info">
          <div className="cta-card__text-content--dual cta-inner-wrapper">
            <div className="cta-text-section">
              <h3 className="cta-card__heading">{translations.aboutUs}</h3>
              <p className="cta-card__description desc-freakyard about-us-freakyard-desc">
                {translations.aboutDescription}
              </p>
            </div>
            <div className="cta-image-section">
              <img
                src={aboutLogo}
                alt="About Freaks of Nature"
                className="cta-card__decorative-logo cta-card__decorative-logo--info"
                loading="lazy"
              />
            </div>
          </div>
        </a>

        <Link to="/affiliate" className="cta-card cta-card--program">
          <div className="cta-card__text-content--dual cta-inner-wrapper">
            <div className="cta-text-section">
              <h3 className="cta-card__heading">{translations.affiliate}</h3>
              <p className="cta-card__description desc-freakyard affiliate-freakyard-desc">
                {translations.affiliateDescription}
              </p>
            </div>
            <div className="cta-image-section">
              <img
                src={resmailLogo}
                alt="Affiliate Program"
                className="cta-card__decorative-logo cta-card__decorative-logo--program"
                loading="lazy"
              />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default AffiliateCards;